import {
    KmsTypeCategoryMembership,
    KmsTypePublishEntryCategories,
    KmsTypePublishUserCategories,
} from "@kaltura/mediaspace-shared-types";
import { PublishedCategories } from "./published-categories/PublishedCategories";
import { PublishTabs } from "./publish-tabs/PublishTabs";

export interface PublishLocationsProps {
    entryCategories: KmsTypePublishEntryCategories;
    userCategories: KmsTypePublishUserCategories;
    entryIds: string[];
    crossApplicationUnpublishing: boolean;
    onLocationsCount: (count: number) => void;
    onCategoryChange: (categoryId: number, checked: boolean) => void;
    onUnpublishExternal: () => void;
    isBulk?: boolean;
    disabledCategoryMembershipIds?: KmsTypeCategoryMembership[];
}

/**
 * Publish locations - current entry categories and potential categories the user can publish to
 */
export function PublishLocations(props: PublishLocationsProps) {
    const {
        entryCategories,
        userCategories,
        entryIds,
        crossApplicationUnpublishing,
        onLocationsCount,
        onCategoryChange,
        onUnpublishExternal,
        isBulk,
        disabledCategoryMembershipIds,
    } = props;

    return (
        <div className="kms-ds-publish-locations">
            <PublishedCategories
                entryCategories={entryCategories}
                entryIds={entryIds}
                onLocationsCount={onLocationsCount}
                onDelete={(categoryId) => onCategoryChange(categoryId, false)}
                isBulk={isBulk}
            />

            <PublishTabs
                entryCategories={entryCategories}
                userCategories={userCategories}
                entryIds={entryIds}
                crossApplicationUnpublishing={crossApplicationUnpublishing}
                onCategoryChange={onCategoryChange}
                onUnpublishExternal={onUnpublishExternal}
                isBulk={isBulk}
                disabledCategoryMembershipIds={disabledCategoryMembershipIds}
            />
        </div>
    );
}
